import { useQueryClient } from "@tanstack/react-query";
import { Input, message, Row } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../molecules/Button";
import { useCreateNote } from "./api";

type CreateNoteFormProps = {
  onClose: () => void;
};

export const CreateNoteForm = (props: CreateNoteFormProps) => {
  const { onClose } = props;

  const queryClient = useQueryClient();
  const { bookingDetails } = useSelector((state: any) => state.newBooking);
  const [note, setNote] = useState("");

  const isEmptyNote = !note || note.trim() === "";
  const moduleId = bookingDetails?.leaseId;

  const { createNote, isPending } = useCreateNote({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notes", moduleId] });
      onClose?.();
    },
    onError: () => message.error("Error occurred while creating note"),
  });

  const handleSubmit = async () => {
    await createNote({ note, type: "internal", moduleId, link: location?.href });
  };

  return (
    <div>
      <Row>
        <Input.TextArea autoSize={{ minRows: 3 }} onChange={(event) => setNote(event.target.value)} />
      </Row>
      <Row justify="end" style={{ marginTop: "20px", gap: "0.5rem" }}>
        <Button label="Cancel" className="bf-save-draft-button" disabled={isPending} onClick={onClose} />
        <Button
          label={isPending ? "Submitting..." : "Submit"}
          className="ef-approve-btn"
          onClick={handleSubmit}
          disabled={isPending || isEmptyNote}
        />
      </Row>
    </div>
  );
};
